/**
 * Mock bundle design for the "Double Solid Shelf" inseparable soft bundle (ISB) choice
 * (catalog choice 280104, see packoutMockData.js). "Double" means two of the SAME solid
 * shelf part used in Single Solid Shelf (same Sku/ChoiceId, 324536656/284359) — not a
 * different, wider shelf. Same geometry as wallStorage-isb-doubleWireShelf.mock.js
 * (the solid shelf shares the wire shelf's physical spec per catalog confirmation) —
 * only the shelf's own Sku/ChoiceId/Name differ. See that file for why bracket-to-bracket
 * is exactly SHELF_WIDTH (not bracket-width + shelf-width) and why shelf[i] nudges off
 * its own bracket by a FULL CELL_WIDTH rather than half.
 */

const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000014';
const BRACKET_CHOICE_ID = 284358; // shared "Shelf Bracket" part choice, hidden from selector
const SHELF_CHOICE_ID = 284359; // same Solid Shelf part choice as Single Solid Shelf
const CELL_WIDTH = 330; // centiunits (3.3in), the bracket's own physical width
const SHELF_WIDTH = 2100; // centiunits (21in), the shelf's own physical width

const CELL_HEIGHT = 380; // centiunits (3.8in)

const BRACKET_1_COLUMN = 0;
const SHELF_1_COLUMN = BRACKET_1_COLUMN + CELL_WIDTH;
const BRACKET_2_COLUMN = BRACKET_1_COLUMN + SHELF_WIDTH;
const SHELF_2_COLUMN = BRACKET_2_COLUMN + CELL_WIDTH;
const BRACKET_3_COLUMN = BRACKET_2_COLUMN + SHELF_WIDTH;

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Double Solid Shelf (mock ISB)',
  Version: 1,
  ProductTypeId: null,
  Sku: null,
  Surface: null,
  Matrix: null,
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'isb-double-solid-shelf-bracket-1',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: BRACKET_1_COLUMN, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-solid-shelf-shelf-1',
      Type: 'Accessory',
      Sku: 324536656,
      Name: 'Double Solid Shelf (mock)',
      ChoiceId: SHELF_CHOICE_ID,
      Origin: {
        Row: 0, Column: SHELF_1_COLUMN, Height: CELL_HEIGHT / 2, Width: SHELF_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-solid-shelf-bracket-2',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: BRACKET_2_COLUMN, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-solid-shelf-shelf-2',
      Type: 'Accessory',
      Sku: 324536656,
      Name: 'Double Solid Shelf (mock)',
      ChoiceId: SHELF_CHOICE_ID,
      Origin: {
        Row: 0, Column: SHELF_2_COLUMN, Height: CELL_HEIGHT / 2, Width: SHELF_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 4,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-solid-shelf-bracket-3',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: BRACKET_3_COLUMN, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 5,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const wallStorageIsbDoubleSolidShelfMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default wallStorageIsbDoubleSolidShelfMock;
